'use client';
import Loader from "./Loader.js";
export default Loader;